// Reads what the API sent back. Errors keep the API's JSON body so pages can explain them (409
// conflicts, "not configured", and so on).
//
// Every API reply is JSON. A reply that isn't is a refusal: CloudFront serves the app's index.html
// with a 200 for any 403 or 404 from the origin (CLAUDE.md, "The SPA fallback hides API errors"),
// so an HTML page on /api means signed out or no access, never an empty success.

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: { error?: string; [k: string]: unknown },
  ) {
    super(body.error ?? `HTTP ${status}`);
    this.name = "ApiError";
  }
}

export async function readResponse(res: Response): Promise<Record<string, unknown>> {
  if (!/^application\/json\b/i.test(res.headers.get("content-type") ?? "")) {
    throw new ApiError(res.status, { error: "refused", detail: "Ask HR didn't accept the request. Sign out and back in; tell IT if it keeps happening." });
  }
  const json = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) throw new ApiError(res.status, json);
  return json;
}
